module.exports = __webpack_public_path__ + "static/media/static.ee1415df.sass";


//////////////////
// WEBPACK FOOTER
// ./src/components/Static/static.sass
// module id = 1300
// module chunks = 0